import { AttachmentDetails, TypeOfAttachment } from 'owa-addins-core';
import {
    AttachmentFile,
    AttachmentFileType,
    AttachmentFileAttributes,
    MailItemFile,
    UriFile,
} from 'owa-attachment-file-types';
import { getExtensionFromFileName } from 'owa-file';

export default function createAttachmentFiles(
    attachments: AttachmentDetails[]
): AttachmentFileAttributes[] {
    const attachmentFiles: AttachmentFileAttributes[] = [];
    for (const attachment of attachments) {
        let file: AttachmentFile = null;
        if (attachment.attachmentType == TypeOfAttachment.Item) {
            file = <MailItemFile>{
                fileType: AttachmentFileType.MailItem,
                name: attachment.name,
                size: attachment.size,
                itemId: attachment.id,
            };
        } else if (attachment.attachmentType == TypeOfAttachment.File) {
            file = <UriFile>{
                fileType: AttachmentFileType.Uri,
                name: attachment.name,
                size: attachment.size,
                uri: attachment.id,
                type: getExtensionFromFileName(attachment.id),
            };
        }

        if (file) {
            attachmentFiles.push({ file: file, isInline: attachment.isInline });
        }
    }
    return attachmentFiles;
}
